import { AppointmentsDetailsInterface } from '../../../interfaces/dto/appointments-details/appointments-details-interface';

export class CpAppointmentsDetailsModel implements AppointmentsDetailsInterface {
  appointmentStatus: string = '';
  cityName: string = '';
  contact: string = '';
  countryName: string = '';
  dateOfTreatment: string = '';
  dateRequested: string = '';
  districtName: string = '';
  encounterId: string = '';
  notes: string = '';
  personName: string = '';
  serviceName: string = '';
  specialtyName: string = '';
  subserviceName: string = '';
  buildingName: string = '';
  buildingContact: string = '';
  buildingAddress: string = '';
  buildingDistrictName: string = '';
  buildingCityName: string = '';

  constructor(init?: Partial<CpAppointmentsDetailsModel>) {
    Object.assign(this, init);
  }
}
